export default "__VITE_PUBLIC_ASSET__74bb6a1c__"